var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadband(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6 -9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A4A4A4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.893 4.545C.32 3.962.003 3.187.003 2.364.004 1.54.32.766.894.182c.173-.177.454-.177.627 0 .173.176.173.466 0 .642-.405.412-.627.956-.627 1.54 0 .584.222 1.131.627 1.543.173.177.173.462 0 .638-.085.091-.2.132-.311.132-.116 0-.231-.041-.316-.132zM9.23 3.907c.404-.412.626-.96.626-1.543 0-.584-.222-1.128-.627-1.54-.173-.176-.173-.466 0-.642.174-.177.458-.177.632 0 .573.584.884 1.358.884 2.182 0 .823-.31 1.598-.884 2.181-.09.091-.2.132-.316.132-.111 0-.227-.041-.316-.132-.173-.176-.173-.461 0-.638zM2.703 3.59c-.663-.674-.663-1.774 0-2.453.173-.177.453-.177.626 0 .174.176.174.462 0 .643-.15.154-.235.362-.235.584 0 .221.084.43.235.588.174.177.174.462 0 .638-.084.09-.2.132-.31.132-.116 0-.227-.041-.316-.132zM7.42 2.952c.155-.158.24-.367.24-.588 0-.222-.085-.43-.24-.584-.174-.181-.174-.467 0-.643.173-.177.458-.177.631 0 .663.679.663 1.779 0 2.453-.089.09-.204.132-.316.132-.115 0-.226-.041-.315-.132-.174-.176-.174-.461 0-.638z",
    transform: "translate(3 3) translate(3.277 5.958)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3D43",
    fillRule: "nonzero",
    d: "M17.618 6.777H5.819V4.306c0-.25-.195-.453-.444-.453-.245 0-.445.204-.445.453v2.471H1.8c-.791 0-1.436.657-1.436 1.462v3.352c0 .806.645 1.462 1.436 1.462h15.818c.791 0 1.436-.656 1.436-1.462V8.24c0-.805-.645-1.462-1.436-1.462z",
    transform: "translate(3 3) translate(3.277 5.958)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF5656",
    d: "M4.022 11.246c-.054.06-.12.104-.192.134-.072.03-.15.05-.228.05-.085 0-.157-.02-.235-.05-.072-.03-.132-.073-.192-.134-.114-.117-.175-.27-.175-.429 0-.165.06-.318.175-.434.222-.227.625-.233.847 0 .115.116.18.269.18.434 0 .16-.065.312-.18.429z",
    transform: "translate(3 3) translate(3.277 5.958)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7EC732",
    d: "M4.15 9.02c-.03.073-.073.14-.133.201-.053.055-.12.098-.191.128-.072.03-.15.049-.227.049-.084 0-.156-.018-.234-.049-.071-.03-.131-.073-.191-.128-.054-.06-.102-.128-.132-.2C3.012 8.946 3 8.867 3 8.788c0-.08.012-.159.042-.232.03-.079.078-.14.132-.2.03-.025.06-.055.09-.074.036-.024.065-.042.101-.06.042-.013.078-.025.114-.031.197-.043.4.024.538.164.06.061.102.122.132.201.03.073.048.153.048.232 0 .079-.018.158-.048.231z",
    transform: "translate(3 3) translate(3.277 5.958)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadband);
export default __webpack_public_path__ + "static/media/broadband.90e4edf24471b6000e24d2098b532eeb.svg";
export { ForwardRef as ReactComponent };